import { render, staticRenderFns } from "./FurnitureForm.vue?vue&type=template&id=d6b021f0&lang=pug"
import script from "./FurnitureForm.vue?vue&type=script&lang=ts"
export * from "./FurnitureForm.vue?vue&type=script&lang=ts"
import style0 from "./FurnitureForm.vue?vue&type=style&index=0&id=d6b021f0&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AvailabilityRemark: require('/app/components/generic/AvailabilityRemark.vue').default,NewLocationPickupInput: require('/app/components/generic/NewLocationPickupInput.vue').default,SelRefined: require('/app/components/vantone/SelRefined.vue').default,Checkbox: require('/app/components/vantone/Checkbox.vue').default,NewLocationDeliveryInput: require('/app/components/generic/NewLocationDeliveryInput.vue').default,Icon: require('/app/components/vantone/Icon.vue').default,TextInputError: require('/app/components/generic/forms/TextInputError.vue').default,PhoneNumber: require('/app/components/generic/PhoneNumber.vue').default,Btn: require('/app/components/vantone/Btn.vue').default,RetrieveQuoteModal: require('/app/components/modals/RetrieveQuoteModal.vue').default,SlideRightTransition: require('/app/components/generic/SlideRightTransition.vue').default})
